import React from 'react'
import './Footer.css'

const Footer = () => {

  return (
    <footer className="Footer">
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-12 col-lg-5 mb-5">
            <div className="row justify-content-between">
              <div className="col Footer-title">Main</div>
              <div className="col Footer-title">UX/UI Design</div>
            </div>
            <div className="row justify-content-between">
              <div className="col"><a className="Footer__link" href="/">About us</a></div>
              <div className="col"><a className="Footer__link" href="/">Usability Testing</a></div>
            </div>
            <div className="row justify-content-between">
              <div className="col"><a className="Footer__link" href="/">Contacts</a></div>
              <div className="col"><a className="Footer__link" href="/">Blog</a></div>
            </div>
          </div>

          <div className="col-12 col-lg-5 mb-3">
            <div className="row justify-content-between">
              <div className="col Footer-title">Contact us</div>
              <div className="col Footer-title">Follow us</div>
            </div>
            <div className="row justify-content-between">
              <div className="col"><a className="Footer__link Footer-icon Linkedin" href="/">Linkedin</a></div>
              <div className="col"><a className="Footer__link Footer-icon Behance" href="/">Behance</a></div>
            </div>
            <div className="row justify-content-between">
              <div className="col"><a className="Footer__link Footer-icon Telegram" href="/">Telegram</a></div>
              <div className="col"><a className="Footer__link Footer-icon Youtube" href="/">Youtube</a></div>
            </div>
            <div className="row justify-content-between">
              <div className="col"><a className="Footer__link Footer-icon Whatsapp" href="/">Whatsapp</a></div>
              <div className="col"><a className="Footer__link Footer-icon Instagram" href="/">Instagram</a></div>
            </div>
            <div className="row justify-content-between">
              <div className="col"><a className="Footer__link Footer-icon Facebook" href="/">Facebook</a></div>
              <div className="col"><a className="Footer__link Footer-icon Medium" href="/">Medium</a></div>
            </div>
            <div className="row justify-content-between">
              <div className="col"><a className="Footer__link Footer-icon Email" href="/">ilove@opium.pro</a></div>
              <div className="col"><a className="Footer__link Footer-icon Habr" href="/">Habr</a></div>

            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="Footer-rights">
              © Every time you brake copyright rules,
              Hitler becomes more alive
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer